export function enableExpoCliLogging(): void {
  console.warn('Expo.Logs.enableExpoCliLogging: is not supported on web');
}
export function disableExpoCliLogging(): void {
  console.warn('Expo.Logs.disableExpoCliLogging: is not supported on web');
}
